module.exports = __webpack_public_path__ + "44f3efd42ae72816ae991340001fc1e4.svg";